interface Props {
  width?: string | number;
  height?: string | number;
  backgroundColor: string;
  radius?: string | number;
}

export default function ColorSwatch({
  width = 18,
  height = 18,
  backgroundColor,
  radius = 4,
}: Props) {
  return (
    <div style={{ width, height, backgroundColor, borderRadius: radius }} />
  );
}
